// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"2ddb3c6a4bbedebfb3a0","691":"30dde37b64f9ac063ff3","731":"478293a1f690ce2fee97","843":"51c8fe8df9f8454fef2b"}[chunkId] + ".js";
};